import ZlbConfirm from '@/components/ZlbConfirm';
import { 
  reqReimburseType,
  reqEconomicSubject,
  reqRelationChange,
  reqUnlikeBudget,
  reqManageValidation,
} from '../services';

const responseErrorHandle = (res) => {
  const { success, message, statusText } = res;
  if (!success) {
    ZlbConfirm({
      title: message || statusText,
      showOkBtn: false,
      cancelText: '知道了',
    });
  }
  return success;
};

export default {
  namespace: 'economicSubject',
  state: {
    reimburseTypeList: [],
  },
  effects: {
    * manageValidation ({ payload }, { call }) {
      const res = yield call(reqManageValidation, payload);
      responseErrorHandle(res);
      return res;
    },

    * getReimburseType ({ payload }, { call, put }) {
      const res = yield call(reqReimburseType, payload);
      responseErrorHandle(res);
      yield put({
        type: 'update',
        payload: {
          reimburseTypeList: res.result || [],
        },
      });
    },
    
    * getEconomicSubjectList ({ payload }, { call }) {
      const res = yield call(reqEconomicSubject, payload);
      responseErrorHandle(res);
      return res;
    },

    * relationChange ({ payload }, { call }) {
      const res = yield call(reqRelationChange, payload);
      responseErrorHandle(res);
      return res;
    },

    * unlikeBudget ({ payload }, { call }) {
      const res = yield call(reqUnlikeBudget, payload);
      responseErrorHandle(res);
      return res;
    },
  },
  reducers: {
    update (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};

